var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2375_14538",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2375_14538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 7.99995C21.5333 7.99995 22 8.19995 22.4 8.59995C22.8 8.99995 23 9.46662 23 9.99995V11.9999C23 12.1166 22.9875 12.2416 22.9625 12.3749C22.9375 12.5083 22.9 12.6333 22.85 12.7499L19.85 19.7999C19.7 20.1333 19.45 20.4166 19.1 20.65C18.75 20.8833 18.3833 21 18 21H10C9.45 21 8.97917 20.8041 8.5875 20.4125C8.19583 20.0208 8 19.5499 8 19V8.82495C8 8.55828 8.05417 8.30412 8.1625 8.06245C8.27083 7.82078 8.41667 7.60828 8.6 7.42495L14.025 2.02495C14.275 1.79162 14.5708 1.64995 14.9125 1.59995C15.2542 1.54995 15.5833 1.60828 15.9 1.77495C16.2167 1.94162 16.4458 2.17495 16.5875 2.47495C16.7292 2.77495 16.7583 3.08328 16.675 3.39995L15.55 7.99995H21ZM4 21C3.45 21 2.97917 20.8041 2.5875 20.4125C2.19583 20.0208 2 19.5499 2 19V9.99995C2 9.44995 2.19583 8.97912 2.5875 8.58745C2.97917 8.19578 3.45 7.99995 4 7.99995C4.55 7.99995 5.02083 8.19578 5.4125 8.58745C5.80417 8.97912 6 9.44995 6 9.99995V19C6 19.5499 5.80417 20.0208 5.4125 20.4125C5.02083 20.8041 4.55 21 4 21Z",
    fill: "#1D92FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.6450215587cc1b103d1db6e6d3d8b6c2.svg";
export { ForwardRef as ReactComponent };